// @mui
import { Card, CardHeader, Skeleton, Stack } from '@mui/material';

// ----------------------------------------------------------------------

export default function SkeletonFeed() {
  return (
    <Card>
      <CardHeader
        disableTypography
        avatar={<Skeleton variant="circular" width={40} height={40} />}
        title={<Skeleton variant="text" height={20} width={50} />}
        subheader={<Skeleton variant="text" height={20} width={80} />}
      />
      <Stack spacing={3} sx={{ p: 3 }}>
        <Skeleton variant="text" height={20} width={150} />
        <Skeleton variant="text" height={20} width={90} />

        {/* <Stack direction="row" alignItems="center">
            <Stack direction="row" alignItems="center" spacing={1}>
              <Skeleton variant="text" height={30} width={30} />
              <Skeleton variant="text" height={20} width={20} />
            </Stack>

            <Box sx={{ flexGrow: 1 }} />
            <IconButton>
              <Skeleton variant="text" height={40} width={40} />
            </IconButton>
          </Stack> */}
      </Stack>
    </Card>
  );
}
